import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    Renderer2,
    ViewChildren,
} from '@angular/core';
import { FileType } from '@fi-shared/types';
import { getAcceptByFileType } from '@fi-shared/utils/get-accept-by-file-type';
import { IInsertMediaResult } from '@fi-shared/fi-insert-media/fi-insert-media';
import { FiInsertMedia2Service } from '@fi-shared/fi-insert-media/fi-insert-media2.service';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { FiMediaStorageService } from '@fi-shared/media-bank/fi-media-storage.service';
import { IEditObjectDialogData, IEditObjectDialogDataItem } from '@fi-shared/fi-edit-object-dialog/fi-edit-object';

@Component({
    selector: 'fi-object-edit-image',
    templateUrl: './fi-object-edit-image.component.html',
    styleUrls: ['./fi-object-edit-image.component.scss'],
    standalone: false,
})
export class FiObjectEditImageComponent implements OnInit {
    @ViewChildren('imageEditorContainer') imageEditorContainers: QueryList<ElementRef>;
    @Input() changedItem: IEditObjectDialogDataItem;
    @Input() dialogData: IEditObjectDialogData;
    @Output() onValueChanged = new EventEmitter<void>();

    constructor(
        private fiInsertMedia2Service: FiInsertMedia2Service,
        private mediaStorageService: FiMediaStorageService,
        private renderer: Renderer2,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.setInitialBackgroundImage();
    }

    private setInitialBackgroundImage() {
        if (!this.changedItem.MediaBankFileReferences?.length) {
            this.changedItem.MediaBankFileReferences = [];
        } else {
            setTimeout(() => {
                this.setBackgroundImage(this.getImageUrl(this.changedItem.MediaBankFileReferences[0]));
            });
        }
    }

    isImageAttached(): boolean {
        return !!this.changedItem.MediaBankFileReferences?.length;
    }

    openAttachmentDialog() {
        this.fiInsertMedia2Service
            .openInsertMediaDialogWithFileSizes(this.dialogData.objectType, {
                multiple: false,
                fileTypes: [FileType.Image],
                accept: getAcceptByFileType([FileType.Image], undefined),
            })
            .onYesButtonClick((result: IInsertMediaResult) => {
                this.setMediaBankReferences(result.mediaBankFileReferences);
                this.onValueChanged.emit();
            });
    }

    private setMediaBankReferences(mediaBankFileReferences: IMediaBankFileReference[]) {
        this.changedItem.MediaBankFileReferences = mediaBankFileReferences;
        this.setBackgroundImage(this.getImageUrl(this.changedItem.MediaBankFileReferences[0]));
    }

    private setBackgroundImage(imgUrl: string = '') {
        this.imageEditorContainers.forEach((elementRef: ElementRef) => {
            this.renderer.setStyle(elementRef.nativeElement, 'background-image', `url(${imgUrl})`);
        });

        this.cdr.markForCheck();
    }

    private getImageUrl(mediaBankReferences: IMediaBankFileReference): string {
        return this.mediaStorageService.getMediaFileUrl(mediaBankReferences);
    }

    clearMediaBankReferences() {
        this.setBackgroundImage();
        this.changedItem.MediaBankFileReferences = [];
    }
}
